<template>
  <div class="container login">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="logo">
          <img src="@/csmworkflow/img/logo.svg" />
        </div>
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">Reset Password</h5>
            <div class="alert alert-danger" v-show="error">{{ error }}</div>
            <div class="alert alert-success" v-show="success">{{ success }}</div>
            <form @submit.prevent="resetPassword" class="form-signin">
                <div class="form-label-group">
                <input
                    :type="showPassword ? 'text' : 'password'" 
                    id="password"
                    class="form-control"
                    v-model="password"
                    placeholder="Password"
                    required
                    autofocus
                    @input="validatePassword($event.target.value)"
                />
                  <span class="toggle-password top-45" @click="togglePassword">
                    <i v-if="showPassword" class="fas fa-eye"></i>
                    <i v-else class="fas fa-eye-slash"></i>
                  </span>
                <label for="password">Password</label>
                <password v-model="password" :strength-meter-only="true" style="max-width: unset; margin: 0; margin-bottom: -10px;" />
                </div>
                <div class="form-label-group">
                <input
                    :type="showConfirmPassword ? 'text' : 'password'" 
                    id="confirmPassword"
                    class="form-control"
                    v-model="password_confirmation"
                    placeholder="Confirm Password"
                    required
                    autofocus
                />
                  <span class="toggle-password top-50" @click="toggleConfirmPassword">
                    <i v-if="showConfirmPassword" class="fas fa-eye"></i>
                    <i v-else class="fas fa-eye-slash"></i>
                  </span>
                <label for="confirmPassword">Confirm Password</label>
                </div>
                <div>
                  <ul class="password-checklist">
                    <li :class="{'pw-list-item': true, 'pass': checkPwConditionReached('min') == 'pass', 'error': checkPwConditionReached('min') == 'err'}">
                        <span class="pw-list-check"><i :class="`fas ${getPwListIcon('min')}`"></i></span> At least 8 letters
                    </li>
                    <li :class="{'pw-list-item': true, 'pass': checkPwConditionReached('uppercase') == 'pass', 'error': checkPwConditionReached('uppercase') == 'err'}">
                        <span class="pw-list-check"><i :class="`fas ${getPwListIcon('uppercase')}`"></i></span> At least 1 capital letters
                    </li>
                    <li :class="{'pw-list-item': true, 'pass': checkPwConditionReached('lowercase') == 'pass', 'error': checkPwConditionReached('lowercase') == 'err'}">
                        <span class="pw-list-check"><i :class="`fas ${getPwListIcon('lowercase')}`"></i></span> At least 1 lower case letters
                    </li>
                    <li :class="{'pw-list-item': true, 'pass': checkPwConditionReached('symbols') == 'pass', 'error': checkPwConditionReached('symbols') == 'err'}">
                        <span class="pw-list-check"><i :class="`fas ${getPwListIcon('symbols')}`"></i></span> At least 1 special characters (!$#@%^*&amp;{}[]&lt;&gt;)
                    </li>
                    <li :class="{'pw-list-item': true, 'pass': checkPwConditionReached('digits') == 'pass', 'error': checkPwConditionReached('digits') == 'err'}">
                        <span class="pw-list-check"><i :class="`fas ${getPwListIcon('digits')}`"></i></span> At least 1 numberic digits
                    </li>
                  </ul>
                </div>
                <button
                class="btn btn-lg btn-primary btn-block text-uppercase"
                type="submit"
                >Reset</button>
                <hr />
                <router-link class="btn btn-lg btn-success btn-block text-uppercase" to="/login">Back to Login</router-link>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Password from 'vue-password-strength-meter';
import passwordValidator from 'password-validator';

export default {
  name: "PasswordReset",
  components: {
    Password
  },
  data() {
    return {
      password: "",
      password_confirmation: "",
      error: "",
      success: "",
      showConfirmPassword: false,
      showPassword: false,
      pwValidator: null,
      pwValidateList: [],
      pwValidateErrorList: [],
    };
  },
  methods: {
    resetPassword() {
      this.pwValidateErrorList = this.pwValidator.validate(this.password, { list: true });
      if (this.pwValidateErrorList.length > 0) {
          return;
      }

      let password_confirmation = this.password_confirmation,
        password = this.password,
        email = this.$route.query.email,
        token = this.$route.params.token;

      if(password != password_confirmation) {
          this.error = 'Confirmation password does not match';
          return;
      }

      this.$store
        .dispatch("resetPassword", { email, password, password_confirmation, token })
        .then((response) => {
          if(response.data.success) {
            this.success = response.data.msg;
            this.redirectAfterSuccess(response);
          } else {
            this.error = response.data.msg;
          }
        })
        .catch(err => {
          console.error(err);
          this.error = "Password could not be reset at the moment. Please try again later.";
        });
    },

    redirectAfterSuccess(response) {
      let countdown = 6;
      let redirectCd = setInterval(() => {
        if (countdown <= 0) {
          this.$store.dispatch("setLoginInformation", response);
          this.$router.push('/my-week');
          clearInterval(redirectCd);
        } else {
          countdown--;
          this.success = `Password reset! Redirecting to dashboard in ${countdown} seconds...`;
        }
      }, 1000);
    },

    // Hardcoded password requirement
    initPasswordValidator() {
      if (!this.pwValidator) {
        this.pwValidator = new passwordValidator();

        this.pwValidator.is().min(8).has().uppercase().has().lowercase().has().digits(1).has().symbols();
        this.pwValidateList = this.pwValidator.validate('', { list: true });
      }
    },
    validatePassword(password) {
      this.initPasswordValidator();
      this.pwValidateList = this.pwValidator.validate(password, { list: true });
      this.pwValidateErrorList = this.pwValidateErrorList.filter(x => this.pwValidateList.includes(x));
    },
    checkPwConditionReached(name) {
      if (this.pwValidateErrorList.includes(name)) {
        return 'err';
      }
      if (!this.pwValidateList.includes(name)) {
        return 'pass';
      }

      return 'pending'
    },
    getPwListIcon(name) {
      let code = this.checkPwConditionReached(name);
      if (code == 'err') {
        return 'fa-times';
      }
      if (code == 'pass') {
        return 'fa-check';
      }
      return 'fa-circle';
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
  },
  mounted() {
    this.initPasswordValidator();
  },
};
</script>
<style scoped>
.toggle-password {
  position: absolute;
  right: 1.5rem;
  transform: translateY(-50%);
  cursor: pointer;
}

.top-50 {
  top: 50%;
}

.top-45 {
  top: 45%;
}
</style>